import { Place } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import ReadMoreHTML from "app/components/ReadMoreHTML";
import DOMPurify from "dompurify";
function JobDescription({ cities, states, countries, description }) {
  const sanitizedDescription = DOMPurify.sanitize(description);
  return (
    <>
      <Typography variant={"subtitle1"} margin={0} fontWeight={600}>
        Location
      </Typography>
      <Box display={"flex"} alignItems={"center"} gap={1} color={"gray"} fontSize={".8rem"}>
        <Place />
        <span>{cities}</span>
      </Box>
      <Typography variant={"subtitle1"} margin={0} fontWeight={600}>
        Job Description
      </Typography>
      <Box
        sx={{
          backgroundColor: "#fff",
          border: "1px solid #cecece",
          borderRadius: 3,
          p: 2,
          mb: 1
        }}
      >
        <ReadMoreHTML
          readMoreText="Learn more"
          readLessText="Hide details"
          text={sanitizedDescription}
          maxChars={200}
        />
      </Box>
    </>
  );
}

export default JobDescription;
